import React from "react";
import {useTranslation} from "react-i18next";
import {UiInput} from "../../../ui-components/input/uiInput";
import {LoginErrors} from "../login";


type EnterLoginType = {
    login: string,
    setLogin: (login: string) => void,
    errors: LoginErrors,
    onSubmit?: (event: React.FormEvent<HTMLInputElement>) => void,
}

export const EnterLogin: React.FC<EnterLoginType> = (props) => {
    const { t } = useTranslation()
    
    return (
        <div>
            <UiInput
                placeholder={t("global.username")}
                onChange={(event) => {
                    props.setLogin((event.target as HTMLInputElement).value)
                }}
                isOnError={props.errors.loginIsOnError}
                onSubmit={props.onSubmit}
                name={"username"}
            />

            {props.errors.loginIsOnError &&
                <p className="text-danger">{props.errors.loginErrorMessage}</p>
            }
        </div>
    )
}
